export type DurationKind = "medium" | "short" | "shortest";

// create a method defined on duration kind to return the duration in seconds

const shortToMediumBoundary = Math.floor(60 * 7.51);
const shortestToShortBoundary = Math.floor(60 * 3.5);

export function minimumDurationForDurationKind(
  durationKind: DurationKind
): number {
  switch (durationKind) {
    case "medium":
      return shortToMediumBoundary;
    case "short":
      return shortestToShortBoundary;
    case "shortest":
      return -1;
    default:
      return -1;
  }
}

export function maximumDurationForDurationKind(
  durationKind: DurationKind
): number {
  switch (durationKind) {
    case "medium":
      return 10000000;
    case "short":
      return shortToMediumBoundary;
    case "shortest":
      return shortestToShortBoundary;
    default:
      return 10000000;
  }
}

export interface DurationKindSelectorInterface {
  value: DurationKind;
  label: string;
  color: string;
}

export const mediumDurationKindSelector: DurationKindSelectorInterface = {
  value: "medium",
  label: "Duration: medium",
  color: "blue",
};

export const allDurationKindSeletors: DurationKindSelectorInterface[] = [
  mediumDurationKindSelector,
  {
    value: "short",
    label: "Duration: short",
    color: "red",
  },
  {
    value: "shortest",
    label: "Duration: shortest",
    color: "green",
  },
];
